// Demanding both a letter and a digit spares long ordinary words like
// `redacted_thinking`.
const PER_REQUEST_ID = /\b(?=[\w-]*\d)(?=[\w-]*[a-z])[\w-]{12,}\b/gi;
const NUMBER = /\d+/g;

export function withoutPerRequestDetail(message: string): string {
  return message.replace(PER_REQUEST_ID, "*").replace(NUMBER, "*");
}
